import type { LucideIcon } from "lucide-react";

export enum AnchorSection {
  Features = "features",
  Industries = "industries",
  Contact = "contact",
  BookDemo = "book-demo",
}

export enum FeatureBadgeId {
  UploadVenuesServicesResources = "upload-venues-services-resources",
  GetEventRequestsManageEffortlessly = "get-event-requests-manage-effortlessly",
  GrowYourRevenue = "grow-your-revenue",
}

export enum VenueTypeItemEnum {
  CorporateConference = "corporate-conference",
  RestaurantsCatering = "restaurants-catering",
  HotelsHospitality = "hotels-hospitality",
  CulturalPublic = "cultural-public",
  WeddingsEvents = "weddings-events",
  SportsRecreation = "sports-recreation",
  EducationInstitutions = "education-institutions",
  MusicEntertainment = "music-entertainment",
}

export type VenueTypeUI = {
  id: string;
  icon: LucideIcon;
  name: string;
};

export type VenueTypesSectionProps = {
  title?: string;
  types?: Array<VenueTypeUI>;
  className?: string;
};

export enum StageOption {
  First = "showcase-offering",
  Second = "capture-leads",
  Third = "close-deals",
  Fourth = "manage-coordinate",
}

export enum ShowCaseFeature {
  WhitelabelPortal = "whitelabel-portal",
  BookableResources = "bookable-resources",
  HighlightVenues = "highlight-venues",
  BrandControl = "brand-control",
}

export enum CaptureLeadsFeature {
  SelfServeEventCreation = "self-serve-event-creation",
  EarlyUpsell = "early-upsell",
  SmartRecommendations = "smart-recommendations",
  LiveAvailabilityCheck = "live-availability-check",
}

export enum CloseDealsFeature {
  QuickProposalsESigning = "quick-proposals-e-signing",
  KeepTrack = "keep-track",
  BuiltInCommunication = "built-in-communication",
  SecurePaymentsAutoInvoicing = "secure-payments-auto-invoicing",
}

export enum ManageCoordinatesFeature {
  ManageChangesSourceOfTruth = "manage-changes-source-of-truth",
  StayInControlUpcomingEvents = "stay-in-control-upcoming-events",
  ManageVenuesServicesProducts = "manage-venues-services-products",
  TrackRevenuePerformanceAnalytics = "track-revenue-performance-analytics",
}

export type StageItemUI = {
  id: string;
  badge: string;
  title: string;
  features: Array<{
    id: string;
    text: string;
    icon?: LucideIcon;
  }>;
  media: {
    src: string;
    alt: string;
  };
};

export interface USPSectionProps {
  id?: string;
  title?: string;
  subtitle?: string;
  cards?: Array<{
    id: string;
    icon: LucideIcon;
    title: string;
  }>;
  className?: string;
}

export enum USPOption {
  MONETIZE_RESOURCES = "monetize-resources",
  WHITELABEL_PORTAL = "whitelabel-portal",
  VENUE_FLEXIBILITY = "venue-flexibility",
  AUTOMATION = "automation",
}

export interface ContactSectionProps {
  title?: string;
  emailLabel?: string;
  emailAddress?: string;
  className?: string;
}

export interface DemoFormSectionProps {
  formElement?: React.ReactNode;
  className?: string;
}

export interface DemoRequestFormSectionProps {
  className?: string;
}

export interface JourneySectionProps {
  id: string;
  title?: string;
  stages?: Array<StageItemUI>;
  className?: string;
}

export enum EventCategoryId {
  RestaurantsBar = "restaurants-bar",
  SportsRecreation = "sports-recreation",
  CorporateConference = "corporate-conference",
  HotelsHospitality = "hotels-hospitality",
  MusicEntertainment = "music-entertainment",
}

export enum GoalId {
  MonetizeAllResources = "monetize-all-resources",
  KeepBrandControl = "keep-brand-control",
  SaveHoursOnAdmin = "save-hours-on-admin",
}

export interface GoalsSectionProps {
  id?: string;
  className?: string;
}
